module.exports = __webpack_public_path__ + "static/img/n_3_1.e73a9caa.png";